export enum PortTariffLineOperationDirections {
  LOADING = 'loading',
  DISCHARGE = 'discharge',
  BOTH = 'both',
}
